import {CreatedWarehouseLogin} from 'constants/WarehouseConstants';
import {BenchlingAction} from 'redux-stores/Action';
import combineBenchlingReducers from 'util/combineBenchlingReducers';

import {WarehouseActionType} from './WarehouseActions';

export interface CreateLoginModalState {
  open: boolean;
  creating: boolean;
  label: string;
  createdLogin: CreatedWarehouseLogin | null;
}

export interface WarehouseUIState {
  createLoginModal: CreateLoginModalState;
}

export const CREATE_LOGIN_MODAL_INITIAL_STATE = {
  open: false,
  creating: false,
  label: '',
  createdLogin: null,
};

function reduceCreateLoginModal(
  state: CreateLoginModalState = CREATE_LOGIN_MODAL_INITIAL_STATE,
  action: BenchlingAction
): CreateLoginModalState {
  switch (action.type) {
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_MODAL_OPEN:
      // Use default state but open
      return {
        ...CREATE_LOGIN_MODAL_INITIAL_STATE,
        open: true,
      };
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_MODAL_CLOSE:
      return {
        ...state,
        open: false,
      };
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_LABEL_UPDATE:
      return {
        ...state,
        label: action.label,
      };
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_MODAL_CREATE_START:
      return {
        ...state,
        creating: true,
      };
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_MODAL_CREATE_COMPLETE:
      return {
        ...state,
        createdLogin: action.login,
        creating: false,
      };
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_MODAL_CREATE_FAIL:
      return {
        ...state,
        creating: false,
      };
    default:
      return state;
  }
}

export default combineBenchlingReducers({
  createLoginModal: reduceCreateLoginModal,
});
